import Reveal from "./Reveal";

export default function SectionHeader({ number, title, children }) {
  return (
    <div className="mb-10 sm:mb-14">
      <Reveal>
        <p className="mb-3 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-sky-400">
          {number}
        </p>
        <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        <div className="mt-4 h-px w-16 bg-sky-400/60" />
        {children && <p className="mt-5 max-w-2xl text-sm leading-relaxed text-slate-400 sm:text-base">{children}</p>}
      </Reveal>
    </div>
  );
}
